(function () {
  function initAnnouncementSlick() {
    var content = $('.announcement-bar.custom_sale .announcement-bar__content');
    console.log("content", content);

    if (!content.hasClass('slick-initialized') && typeof $.fn.slick === 'function') {
      content.slick({
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 1
      });
    } else if (content.hasClass('slick-initialized')) {
      // instead of re-initializing on resize, refresh layout
      content.slick('setPosition');
    }
  }

  // init once DOM is ready
  $(document).ready(function () {
    initAnnouncementSlick();

    // refresh on resize
    $(window).on('resize', function () {
      initAnnouncementSlick();
    });
  });
})(); 